/**
 * @author Eric Otto
 */

module.exports = {
    init: function () {
        'use strict';

        const baguetteBox = require('baguettebox.js'),
            links = document.querySelectorAll('.gallery .eow-gallery-link');

        baguetteBox.run('.gallery', {
            onChange: function (currentIndex) {
                ga('send', 'event', 'Images', 'click', links[currentIndex].getAttribute('data-identifier'));
            }
        });
    }
};
